<template>
  <a
    class="edit-content"
    href="#"
    @click.prevent="handleClick()"
  >
    <pvd-icon
      class="m-small-right"
      icon="edit"
      aria-hidden="true"
    />
    {{ isNotIstock === 'true'? pd_content.edit_link_label : pd_content.edit_link }}
  </a>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import navHelper from '../mixins/navHelper';
import utility from '../mixins/utility';

export default {
  name: 'EditLink',
  mixins: [dataHelper, measurement, navHelper, utility],
  props: {
    pageName: {
      type: String,
      default: '',
    },
    isNotIstock: {
      type: String,
      default: 'false',
    },
    userIndex: {
      type: Number,
      default: undefined,
    },
    futureDestinationState: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    handleClick() {
      this.track('edit-link', 'interaction');
      console.log('EditLink', this.futureDestinationState);
      this.handleEditClick(this.pageName, this.userIndex, this.futureDestinationState);
    },
  },
};
</script>

<style scoped>

</style>
